export default {
  get: `query getDiets {
    getDiets
    {
        id,
        name
    }
  }`,
};



// WEBPACK FOOTER //
// ./src/graphql/queries/diet.js